import { apiFetch } from './api';

export const deleteAccount = () =>
  apiFetch<{ ok: true }>(`/account`, { method: 'DELETE' });
